import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./auth";
import {
  addOldGuest,
  deleteTenant,
  getPayments,
  getTenantByID,
} from "./apiService";

const VacateGuest = () => {
  const [guestname, setGuestname] = useState("");
  const [mobileno, setMobileno] = useState("");
  const [aadharno, setAadharno] = useState("");
  const [joindate, setJoindate] = useState("");
  const [rentamt, setRentamt] = useState("");
  const [vacatedate, setVacatedate] = useState("");
  const [payments, setPayments] = useState([]);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const { guestid, pgid, roomid } = useAuth();

  useEffect(() => {
    getTenantByID(guestid)
      .then((res) => {
        setGuestname(res.name);
        setMobileno(res.mobileno);
        setAadharno(res.aadharNo);
        setJoindate(res.joinedDate);
        setRentamt(res.rentAmt);
      })
      .catch((e) => console.log(e));

    getPayments()
      .then((res) => {
        setPayments(res);
      })
      .catch((e) => console.log(e));
  }, [guestid]);

  const handleVacateCancel = () => {
    navigate("/Dashboard/MyPGDetails");
  };

  const handleVacateGuest = () => {
    let errors = {};
    let totalamt = 0;
    if (!vacatedate) errors.vacatedate = "Enter valid vacted date";

    setErrors(errors);

    const fpayments = payments.filter((payment) => {
      return payment.pname === guestname;
    });
    fpayments.forEach((payment) => {
      totalamt += payment.pamount;
      return totalamt;
    });

    // console.log(totalamt);

    if (Object.keys(errors).length === 0) {
      const guest = {
        name: guestname,
        mobileno: mobileno,
        aadharNo: aadharno,
        joinedDate: joindate,
        vacatedDate: vacatedate,
        totalAmt: totalamt,
        pgname: pgid,
        roomNo: roomid,
      };

      addOldGuest(guest);

      deleteTenant(guestid);

      setGuestname("");
      setMobileno("");
      setAadharno("");
      setJoindate("");
      setRentamt("");
      setVacatedate("");
      navigate("/Dashboard/MyPGDetails/RoomDetails");
    }
  };
  return (
    <div className="container">
      <div className="header">Vacate GUEST</div>

      <div className="label">Guest Name: {guestname}</div>

      <div className="label">Mobile No: {mobileno}</div>

      <div className="label">Aadhar No: {aadharno}</div>

      <div className="label">Joining Date: {joindate}</div>
      <div className="label">Rent Amount: {rentamt}</div>

      <div className="label">
        Enter Vacating Date:
        <input
          type="date"
          className="inputbox"
          name="vacateddate"
          value={vacatedate}
          onChange={(e) => setVacatedate(e.target.value)}
        />
        {errors.vacatedate ? (
          <div className="errortext">{errors.vacatedate}</div>
        ) : null}
      </div>

      <div className="errortext">
        <div>Please Verify The Guest Details Before vacate ......!!!!</div>
        <div>Once selecting the vacated can't Revert..!!</div>
      </div>

      <div className="btnContainer-cls">
        <input
          type="submit"
          className="btn-cls"
          value="Vacate"
          onClick={handleVacateGuest}
        />
        <input
          type="submit"
          className="btn-cls"
          value="Cancel"
          onClick={handleVacateCancel}
        />
      </div>
    </div>
  );
};

export default VacateGuest;
